import React, { useEffect, useState } from "react";
import { fetchPageData } from "../endpoint/pageApi";
import InfoComponent from "../components/InfoComponent/InfoComponent";
import MainLayout from "./MainLayout";
import NewsBlogs from "../components/NewsandBlogsSection/NewsBlogs";
import InvitingPartners from "../components/InvitingPartners/InvitingPartners";
import JoinWaitListSection from "../components/JoinWaitlistSection/JoinWaitListSection";
import AchieveMoreSection from "../components/AchieveMoreSection/AchieveMoreSection";
import { baseUrl } from "../utils/base_url";
import HeroComponent from "../components/PageComponent/HeroComponent";
import LegalAssitantSection from "../components/LegalAssitantSection/LegalAssitantSection";
import TrustAndAuthenticSection from "../components/TrustandAuthenticSection/TrustAndAuthenticSection";
import WhyAskFideSection from "../components/WhyAskFide/WhyAskFideSection";
import JourneySection from "../components/JourneySection/JourneySection";
import BlogListing from "../components/BlogListing/BlogListing";
import ProblemSolutionSection from "../components/ProblemSolutionSection/ProblemSolutionSection";
import RevolutionisingLegalPractices from "../components/RevolutionisingLegalPractices/RevolutionisingLegalPractices";
import LearnSection from "../components/LearnSection/LearnSection";
import EarlyAccessSection from "../components/EarlyAccessSection/EarlyAccessSection";
import JobOption from "../components/JobOption/JobOption";
import HowWeHelp from "../components/HowWeHelp/HowWeHelp";
import HowItWorks from "../components/HowItWorks/HowItWorks";
import AboutSecond from "../components/AboutSecond/AboutSecond";
import HomeFourth from "../components/HomeFourth/HomeFourth";
import Solo_PractitionersTop from "../components/Solo_PractitionersTop/Solo_PractitionersTop";
import ShadowCardContainer from "../components/ShadowCardContainer/ShadowCardContainer";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from ".././utils/mediaBreakpoints";
import { InformedCard } from "../pages/Schedule";
import { Link } from "react-router-dom";
import BlogCard from "../components/Blog/BlogCard";
import HomeIconScroller from "../components/HomeIconScroller/HomeIconScroller";
import { Toaster } from "react-hot-toast";
import axios from "axios";

const MainPageLayout = ({ pageEndpoint, allData, isMobile, page }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const [pageData, setPageData] = useState({});
  const [loader, setLoader] = useState(false);
  const [blogData, setBlogData] = useState(null);
  const [filteredItems, setFilteredItems] = useState([]);
  const [userCountryCode, setUserCountryCode] = useState("");
  const [pagination, setPagingation] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(9);

  console.log(blogData);

  useEffect(() => {
    fetchPageData(pageEndpoint, setPageData, setLoader, allData);
  }, [pageEndpoint, allData]);

  console.log("blogDAta DAta", blogData);
  console.log("pagina", pagination);

  useEffect(() => {
    fetchPageData(
      `blogs?pagination[page]=${currentPage}&pagination[pageSize]=${pageSize}`,
      setBlogData,
      setLoader,
      true,
      true,
      setPagingation
    );
  }, [pageSize]);

  useEffect(() => {
    const fetchCountry = async () => {
      let countryCode = "";

      try {
        const res = await axios.get("https://ipapi.co/json/");
        countryCode = res.data?.country || "";
      } catch {
        try {
          const fallbackRes = await axios.get("https://ipwho.is/");
          if (fallbackRes.data?.success) {
            countryCode = fallbackRes.data?.country_code || "";
          }
        } catch (error) {
          console.error(error);
        }
      }

      if (countryCode) {
        setUserCountryCode(countryCode);
        const matched = pageData?.hero?.carousel?.filter(
          (item) => item?.country === countryCode
        );
        setFilteredItems(matched || []);
      }
    };

    fetchCountry();
  }, [pageData]);

  console.log("con", filteredItems);

  function truncateTo30Words(text) {
    const words = text.trim().split(/\s+/);
    if (words.length <= 30) return text;
    return words.slice(0, 30).join(" ") + "...";
  }

  return (
    <>
      {
        <MainLayout loader={loader}>
          <div
            className="container-fluid p-0 overflow-x-hidden"
            style={{ backgroundColor: " #090D23" }}
          >
            <Toaster position="top-center" />
            {pageData?.hero && (
              <HeroComponent
                // bgImage={`${baseUrl}${pageData?.hero?.background_image?.url}`}
                // bgVideos={pageData?.hero?.background_videos}
                // bgImages={pageData?.hero?.background_images}
                // mainHeading={pageData?.hero?.heading}
                // subTitle={pageData?.hero?.sub_heading}
                // buttons={pageData?.hero?.CTAs}
                // tagLine={pageData?.hero?.tag_line}
                topEvents={pageData?.top_events}
                carousel={filteredItems}
              />
            )}
            {/* {pageData?.feature && (
              <InfoComponent infoData={pageData?.feature?.features} />
            )} */}

            {/* {pageData?.achieve_more && (
              <AchieveMoreSection data={pageData?.achieve_more} />
            )} */}

            {/* {pageData?.legal_assistant && (
              <LegalAssitantSection data={pageData?.legal_assistant} />
            )} */}
            {pageData?.how_it_work && (
              <HowItWorks data={pageData?.how_it_work} bgcolor={" #000000"} />
            )}

            {/* {pageData?.about_ask_fides && <HomeIconScroller />} */}

            {pageData?.about_ask_fides && (
              <div
                className="col-12 px-md-5 px-lg-2"
                style={{ paddingBottom: "10rem" }}
              >
                <AboutSecond
                  isMobile={isMobile}
                  imgurl={pageData?.about_ask_fides?.image?.url}
                  heading={pageData?.about_ask_fides?.super_heading}
                  description={pageData?.about_ask_fides?.description}
                  pointers={pageData?.about_ask_fides?.tool_pointers}
                />
              </div>
            )}

            {pageData?.web_quick_linkss?.web_quicks &&
              pageData?.web_quick_linkss?.web_quicks?.map((item, index) => {
                console.log("log", item?.image?.url);

                return (
                  <>
                    <HomeFourth
                      key={index}
                      isMobile={isMobile}
                      imgsrc={item?.image}
                      heading={item?.heading}
                      subHeading={item?.sub_heading}
                      btnClass={
                        index === 0
                          ? "col-md-12 col-lg-6 pb-4 pb-xl-0 col-xl-3"
                          : "col-12 col-lg-6 col-xl-4 pb-4 pb-xl-0"
                      }
                      cards={item?.quickss}
                      cardheight={
                        _576
                          ? "95px"
                          : _768
                          ? "110px"
                          : _992
                          ? "130px"
                          : _1200
                          ? "110px"
                          : _1400
                          ? "90px"
                          : _1500
                          ? "95px"
                          : _1600
                          ? "105px"
                          : _1700
                          ? "130px"
                          : _1800
                          ? "134px"
                          : "134px"
                      }
                    />
                  </>
                );
              })}

            {/* {pageData?.new_hero && pageData.outcomes && (
              <Solo_PractitionersTop
                isMobile={isMobile}
                heading={pageData?.new_hero?.heading}
                toppadding={"2rem"}
                texttopmargin={"4.8rem"}
                headingfs={"fs90"}
                headinglh={"4.8rem"}
                bottomtext={pageData?.new_hero?.sub_heading}
                backgroundColor={" #090D23"}
                textforhome={pageData?.outcomes?.text}
              />
            )} */}
            {pageData?.new_hero && (
              <Solo_PractitionersTop
                heading={pageData?.new_hero?.heading}
                subHeading={pageData?.new_hero?.sub_heading}
                btntext={pageData?.new_hero?.CTA?.text}
                btnbg={pageData?.new_hero?.CTA?.backgroundColor}
                btnclr={pageData?.new_hero?.CTA?.textColor}
                btnurl={pageData?.new_hero?.CTA?.url}
                imgsrc1={`${baseUrl}${pageData?.new_hero?.images[0]?.url}`}
                imgsrcs={pageData?.new_hero?.images}
                imgsrc2={`${baseUrl}${pageData?.new_hero?.images[1]?.url}`}
                imgsrc3={`${baseUrl}${pageData?.new_hero?.images[2]?.url}`}
                isMobile={isMobile}
                toppadding={"3rem"}
                texttopmargin={"4.5rem"}
                headingfs={"fs70"}
                headinglh={"4.2rem"}
                issBottom={true}
              />
            )}
            {pageData?.outcomes && (
              <div
                className="pb-5 mt-0"
                style={{ backgroundColor: " #090D23" }}
              >
                <p
                  className="text-white text-md-center fw500 px-3 px-lg-0 mt-0 pb-5 lh-sm"
                  style={{
                    // lineHeight: "2.5rem",
                    fontSize: _576
                      ? "24px"
                      : _768
                      ? "30px"
                      : _992
                      ? "30px"
                      : _1200
                      ? "35px"
                      : _1400
                      ? "37px"
                      : _1500
                      ? "38px"
                      : _1600
                      ? "38px"
                      : _1700
                      ? "38px"
                      : _1800
                      ? "40px"
                      : "40px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: _768
                      ? pageData?.outcomes?.text
                      : pageData?.outcomes?.text?.replace(/\n/g, "<br/>"),
                  }}
                ></p>
              </div>
            )}

            {pageData?.info_cards && (
              <ShadowCardContainer cards={pageData?.info_cards?.details} />
            )}

            {/* {pageData?.problem_solution && (
              <ProblemSolutionSection data={pageData?.problem_solution} />
            )} */}

            {/* {pageData?.departments && (
              <JobOption data={pageData?.departments} />
            )} */}

            {/* {pageData?.legal_practice && (
              <RevolutionisingLegalPractices
                data={pageData?.legal_practice}
                background={"#000000"}
                cardBackgroundColor={"#070707"}
              />
            )} */}

            {/* {pageData?.investment_opportunity && (
              <RevolutionisingLegalPractices
                data={pageData?.investment_opportunity}
                background={"#0B0E23"}
                cardBackgroundColor="#070D21"
              />
            )} */}

            {/* {pageData?.learn_more && (
              <LearnSection data={pageData?.learn_more} />
            )} */}
            {/* {pageData?.our_journey && (
              <JourneySection data={pageData?.our_journey} />
            )} */}

            {/* {pageData?.why_ask_fide && (
              <WhyAskFideSection data={pageData?.why_ask_fide} />
            )} */}
            {/* {pageData?.trust_and_authentic && (
              <TrustAndAuthenticSection data={pageData?.trust_and_authentic} />
            )} */}
            {/* {pageData?.collaborator && (
              <InvitingPartners
                data={pageData?.collaborator}
                try_ask_fide={pageData?.try_ask_fide}
              />
            )} */}
            {/* {pageData?.resources_to_help && (
              <NewsBlogs data={pageData?.resources_to_help} />
            )} */}
            {/* {pageData?.early_access && (
              <EarlyAccessSection data={pageData?.early_access} />
            )} */}
            {/* {pageData?.try_ask_fide && (
              <JoinWaitListSection data={pageData?.try_ask_fide} />
            )} */}
            {/* {pageData?.how_we_help && (
              <HowWeHelp data={pageData?.how_we_help} />
            )} */}
            {blogData && page === "homepage" ? (
              <div
                className="col-12"
                style={{
                  background: "#1F46BE",
                  height: "max-content", //"1080px"
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  padding: _768 ? "5rem 0" : "8rem 0",
                }}
              >
                <div className="container contwidth p-0">
                  <div className="row">
                    <div className="pb-5 mt-0">
                      <p
                        className="text-white text-md-center fw500 px-3 px-lg-0 mt-0 pb-5 lh-sm"
                        style={{
                          // lineHeight: "2.5rem",
                          fontSize: _576
                            ? "24px"
                            : _768
                            ? "30px"
                            : _992
                            ? "30px"
                            : _1200
                            ? "35px"
                            : _1400
                            ? "37px"
                            : _1500
                            ? "38px"
                            : _1600
                            ? "38px"
                            : _1700
                            ? "38px"
                            : _1800
                            ? "40px"
                            : "40px",
                        }}
                        // dangerouslySetInnerHTML={{
                        //   __html: _768
                        //     ? pageData?.outcomes?.text
                        //     : pageData?.outcomes?.text?.replace(/\n/g, "<br/>"),
                        // }}
                      >
                        From research to real-world impact <br /> our journey in
                        legal innovation with AI.
                      </p>
                    </div>
                    {blogData?.map((item, index) => {
                      if (item.is_popular)
                        return <BlogCard item={item} index={index} />;
                    })}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {pageData?.stay_informeds && <InformedCard data={pageData} />}

            {pageData?.blogs && (
              <BlogListing
                data={blogData}
                setPageSize={setPageSize}
                pageSize={pageSize}
                total={pagination?.total}
              />
            )}
            {/* </div> */}
          </div>
        </MainLayout>
      }
    </>
  );
};

export default MainPageLayout;
